import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../../Atoms/Icon";
import Container from "../../Wrappers/Container";
import EditTextButton from "../../Atoms/Buttons/EditTextButton";

const IconPanelContainer = props => {
  const { title, icon, children, container, editFunction } = props
  return (
    <Container>
      <header className="flex s-color-text s-mb-16px">
        <Icon svg={icon}
          size="1.2em"
          className="s-mr-8px"
        />
        <h4 className="s-mb-0 s-color-current">{title}</h4>
        {editFunction && (
          <EditTextButton className="s-to-right" onClick={editFunction}/>
        )}
      </header>
      <div className={container.className}>
        {children}
      </div>
    </Container>
  );
};

IconPanelContainer.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  container: PropTypes.shape({
    className: PropTypes.string,
  })
};

IconPanelContainer.defaultProps = {
  container: {
    className: '',
  }
}

export default IconPanelContainer;
